import { ClientSecretCredential } from '@azure/identity';
import { Client } from '@microsoft/microsoft-graph-client';
import { Message } from '@microsoft/microsoft-graph-types';

class EmailService {
  private client: Client;

  constructor() {
    // These values should come from environment variables in production
    const credential = new ClientSecretCredential(
      import.meta.env.VITE_AZURE_TENANT_ID,
      import.meta.env.VITE_AZURE_CLIENT_ID,
      import.meta.env.VITE_AZURE_CLIENT_SECRET
    );

    this.client = Client.initWithMiddleware({
      authProvider: {
        getAccessToken: async () => {
          const token = await credential.getToken(['https://graph.microsoft.com/.default']);
          return token?.token || '';
        }
      }
    });
  }

  async sendMail(options: {
    to: string;
    subject: string;
    body: string;
    attachments?: {
      name: string;
      contentType: string;
      content: string;
    }[];
  }): Promise<void> {
    try {
      const apiUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-mail`;
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
          'Accept': 'application/json'
        },
        body: JSON.stringify(options)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to send email');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      throw new Error('Failed to send email');
    }
  }

  // Helper method for certificate emails
  async sendCertificateEmail(
    to: string, 
    name: string, 
    certNumber: string, 
    pdfContent: string
  ): Promise<void> {
    const subject = 'Ihr KI-Kompetenznachweis';
    const body = `
      <h1>Ihr KI-Kompetenznachweis</h1>
      <p>Sehr geehrte(r) ${name},</p>
      <p>anbei finden Sie Ihren KI-Kompetenznachweis.</p>
      <p>Zertifikatsnummer: ${certNumber}</p>
      <p>Mit freundlichen Grüßen<br>Ihr KI-Navigatoren Team</p>
    `;

    await this.sendMail({
      to,
      subject,
      body,
      attachments: [{
        name: `Zertifikat_${name.replace(/\s+/g, '_')}.pdf`,
        contentType: 'application/pdf',
        content: pdfContent
      }]
    });
  }
}

export const emailService = new EmailService();